// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const cognitoHostedUIIdentityProviderMap = {
  Google: 'Google',
  Facebook: 'Facebook',
  Amazon: 'LoginWithAmazon',
  Apple: 'SignInWithApple'
};
export { cognitoHostedUIIdentityProviderMap };
